import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
  orderBy
} from 'firebase/firestore';
import { db } from '../firebase';

const testimoniesCollection = collection(db, 'testimonies');

export const listTestimonies = async ({ approvedOnly = false } = {}) => {
  const constraints = [];
  if (approvedOnly) {
    constraints.push(where('approved', '==', true));
  }
  constraints.push(orderBy('order', 'asc'));
  const q = query(testimoniesCollection, ...constraints);
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
};

export const getTestimony = async (id) => {
  const ref = doc(db, 'testimonies', id);
  const snapshot = await getDoc(ref);
  if (!snapshot.exists()) {
    return null;
  }
  return { id: snapshot.id, ...snapshot.data() };
};

export const createTestimony = async (data) => {
  const docRef = await addDoc(testimoniesCollection, {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  });
  return docRef.id;
};

export const updateTestimony = async (id, data) => {
  const ref = doc(db, 'testimonies', id);
  await updateDoc(ref, {
    ...data,
    updatedAt: serverTimestamp()
  });
};

export const upsertTestimony = async (id, data) => {
  const ref = doc(db, 'testimonies', id);
  await setDoc(
    ref,
    {
      ...data,
      updatedAt: serverTimestamp()
    },
    { merge: true }
  );
};

export const deleteTestimony = async (id) => {
  const ref = doc(db, 'testimonies', id);
  await deleteDoc(ref);
};
